import React from 'react';
import PropTypes from 'prop-types';
import HeadLayout from '../layouts/HeadLayout';

function HeadPageTemplateV3({ title, component: Component }) {
  return (
    <HeadLayout title={title}>
      <Component />
    </HeadLayout>
  );
}

HeadPageTemplateV3.propTypes = {
  component: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default HeadPageTemplateV3;
